var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { namespace } from 'vuex-class';
import { Prop } from 'vue-property-decorator';
import { ResourceService } from "~/services/management-service/resource.service";
var systemManageModule = namespace('system-manage');
var AddUser = /** @class */ (function (_super) {
    __extends(AddUser, _super);
    function AddUser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addParams = {
            name: "",
            url: "",
            resoSort: "",
            type: "",
            parentId: _this.parentId
        };
        return _this;
    }
    /**
     * 新增用户确认
     */
    AddUser.prototype.addUserCommit = function () {
        var _this = this;
        var addForm = this.$refs['add-form'];
        this.resourceService.createResource(this.addParams).subscribe(function (data) {
            //   重置form表单xr
            var addForm = _this.$refs['add-form'];
            addForm.resetFields();
            _this.addParams.deptId = '';
            //   关闭dialog
            _this.$emit('close');
            _this.$message.success('新增资源成功!');
            //   刷新databox
            _this.$emit('refresh');
        });
    };
    /**
     * 新增用户取消
     */
    AddUser.prototype.addUserCancel = function () {
        //   重置form表单
        var addForm = this.$refs['add-form'];
        addForm.resetFields();
        this.addParams.deptId = '';
        //   关闭dialog
        this.$emit('close');
    };
    __decorate([
        Prop()
    ], AddUser.prototype, "parentId", void 0);
    __decorate([
        Dependencies(ResourceService)
    ], AddUser.prototype, "resourceService", void 0);
    AddUser = __decorate([
        Component({
            components: {},
        })
    ], AddUser);
    return AddUser;
}(Vue));
export default AddUser;
